/**
 * @desc 列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.changeApproval.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/changeApproval/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
